import ResourceAdmin from "@/components/admin/ResourceAdmin";
import { absoluteUrl } from "@/lib/adminApi";

const emptyItem = { slug: "", title_ar: "", description_ar: "", icon: "boxes", image: "", order: 0, is_active: true };

export default function CategoriesAdmin() {
  return (
    <ResourceAdmin
      title="الفئات"
      resource="categories"
      testIdPrefix="admin-categories"
      emptyItem={emptyItem}
      columns={[
        {
          key: "image", label: "الصورة",
          render: (r) => r.image ? <img src={absoluteUrl(r.image)} alt="" className="w-12 h-12 rounded-lg object-cover" /> : <div className="w-12 h-12 rounded-lg bg-slate-100" />,
        },
        { key: "title_ar", label: "الاسم" },
        { key: "slug", label: "المعرّف" },
        { key: "order", label: "الترتيب" },
        {
          key: "is_active", label: "الحالة",
          render: (r) => (
            <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${r.is_active ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"}`}>
              {r.is_active ? "مفعّل" : "معطّل"}
            </span>
          ),
        },
      ]}
      fields={[
        { name: "title_ar", label: "الاسم بالعربية", type: "text" },
        { name: "slug", label: "المعرّف (slug)", type: "text", ltr: true },
        { name: "description_ar", label: "الوصف", type: "textarea", rows: 3 },
        { name: "icon", label: "أيقونة (lucide-react)", type: "text", ltr: true, help: "مثل: camera, shield-alert, flame, network" },
        { name: "image", label: "صورة الفئة", type: "image" },
        { name: "order", label: "الترتيب", type: "number", min: 0 },
        { name: "is_active", label: "مفعّل", type: "checkbox" },
      ]}
    />
  );
}
